// @flow
/**
 * Canonical HUD primary subsidy types, mirrored from the backend `HudSubsidyType`
 * enum (the `HUD_MASTER_SUBSIDY_TYPE` map, tier `PRIMARY`) which lives in the
 * fortress-backend repo, not here. Keep this list in sync with that source.
 *
 * The legacy GET /master-hud-subsidies API was removed with ENG-25895. The
 * `priorMasterHUDSubsidyId` field still submits the master UUID `id`, which the
 * backend resolves to its enum via `getSubsidyTypeById`, so the stable ids must
 * match the backend records exactly.
 */

export type HUDMasterSubsidyType = {|
  id: string,
  code: string,
  name: string,
|};

export const HUD_PRIMARY_SUBSIDY_TYPES: Array<HUDMasterSubsidyType> =
  Object.freeze([
    {
      id: '59e52845-4f76-49f6-89f8-2b420dbcc20f',
      code: '0',
      name: 'Market Rent',
    },
    {
      id: 'c5db2ca3-5388-403a-8592-252a72d24733',
      code: '1',
      name: 'Section 8',
    },
    {
      id: 'cb2a6af7-5afc-4dfc-876b-1fc27284f5b2',
      code: '2',
      name: 'Rent Supplement',
    },
    { id: '59933c0e-3114-40f3-86b4-7409884461fa', code: '3', name: 'RAP' },
    {
      id: '1f811c6e-8855-4afe-8313-97ae13b16225',
      code: '4',
      name: 'Section 236PAC',
    },
    { id: 'c0458b2a-73ed-4d68-895b-1755deb7c566', code: '5', name: 'BMIR' },
    {
      id: 'a16f7f2d-45d5-487f-84df-d0d2161801bb',
      code: '6',
      name: '811 PRA Demo',
    },
    {
      id: '5efa5b3d-5011-45b5-8926-d280bb60c904',
      code: '7',
      name: 'Section 202 PRAC',
    },
    {
      id: '6f0563d6-6a56-47d4-8602-4cf566072da5',
      code: '8',
      name: 'Section 811 PRAC',
    },
    {
      id: '278fad21-0317-4076-8a03-fc541f405b7e',
      code: '9',
      name: 'Section 202/162',
    },
  ]);
